/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "64886e462601d958ba2dcee1a81579a330963f60";
